import { PaginationListResponse } from '@/src/infrastructure/interfaces/IAutomation.interface';
import {
  GetIntegrationsListPayload,
  IntegrationDetail,
  IntegrationItem,
  IntegrationStepsData,
} from '@/src/infrastructure/interfaces/IIntegrations.interface';

import { IIntegrationsService } from './IIntegrationsService';

import { DataResponse } from '@/modules/ContactsModule/types/Segments';
import { ExecutionsData, LogReport, LogReportPayload } from '@/modules/IntegrationsModule/types';

export class StubIntegrationsService implements IIntegrationsService {
  getExecutions(id: number, bashId: string): Promise<DataResponse<ExecutionsData>> {
    throw new Error('Method not implemented.');
  }

  getIntegrationReport(
    id: string,
    filters: LogReportPayload
  ): Promise<DataResponse<PaginationListResponse<LogReport>>> {
    throw new Error('Method not implemented.');
  }

  updateIntegrationStatus(id: number, status: boolean): Promise<DataResponse<string>> {
    throw new Error('Method not implemented.');
  }
  getIntegration(id: number): Promise<DataResponse<IntegrationDetail>> {
    throw new Error('Method not implemented.');
  }
  saveIntegration(id: number, stepsData: IntegrationStepsData): Promise<DataResponse<string>> {
    throw new Error('Method not implemented.');
  }
  renameIntegration(name: string, id: number): Promise<DataResponse<string>> {
    throw new Error('Method not implemented.');
  }
  duplicateIntegration(name: string, id: number): Promise<DataResponse<string>> {
    throw new Error('Method not implemented.');
  }
  deleteIntegrations(ids: number[]): Promise<DataResponse<string>> {
    throw new Error('Method not implemented.');
  }
  createIntegration(name: string): Promise<DataResponse<string | IntegrationItem>> {
    throw new Error('Method not implemented.');
  }

  getIntegrationsList(
    filters: GetIntegrationsListPayload
  ): Promise<DataResponse<PaginationListResponse<IntegrationItem>>> {
    throw new Error('Method not implemented.');
  }

  static create(): IIntegrationsService {
    return new StubIntegrationsService();
  }
}
